import styled from 'styled-components';

const FileLabelWrapper = styled.div`
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
    flex: 1;
`;

export default FileLabelWrapper;